export class FindPackageComboRequest {
  ABMP: string = null;
  ASCP: string = null;
  AHP: string = null;
  ANP: string = null;
}
